/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './app/routes/__root'
import { Route as AuthrequeiredImport } from './app/routes/_auth_requeired'
import { Route as AuthnotrequeiredImport } from './app/routes/_auth_not_requeired'
import { Route as AuthrequeiredIndexImport } from './app/routes/_auth_requeired/index'
import { Route as AuthrequeiredHelpImport } from './app/routes/_auth_requeired/help'
import { Route as AuthnotrequeiredSignupImport } from './app/routes/_auth_not_requeired/signup'
import { Route as AuthnotrequeiredRegisterImport } from './app/routes/_auth_not_requeired/register'
import { Route as AuthnotrequeiredLogoutImport } from './app/routes/_auth_not_requeired/logout'
import { Route as AuthnotrequeiredLoginImport } from './app/routes/_auth_not_requeired/login'
import { Route as AuthnotrequeiredForgotPasswordImport } from './app/routes/_auth_not_requeired/forgot-password'
import { Route as AuthrequeiredShipperIndexImport } from './app/routes/_auth_requeired/shipper/index'
import { Route as AuthrequeiredNotificationsIndexImport } from './app/routes/_auth_requeired/notifications/index'
import { Route as AuthrequeiredCarrierIndexImport } from './app/routes/_auth_requeired/carrier/index'
import { Route as AuthrequeiredAdminIndexImport } from './app/routes/_auth_requeired/admin/index'
import { Route as AuthrequeiredShipperCargosIndexImport } from './app/routes/_auth_requeired/shipper/cargos/index'
import { Route as AuthrequeiredNotificationsIdIndexImport } from './app/routes/_auth_requeired/notifications/$id/index'
import { Route as AuthrequeiredMasterDataVehiclesIndexImport } from './app/routes/_auth_requeired/master-data/vehicles/index'
import { Route as AuthrequeiredCompaniesIdIndexImport } from './app/routes/_auth_requeired/companies/$id/index'
import { Route as AuthrequeiredCarrierCargosIndexImport } from './app/routes/_auth_requeired/carrier/cargos/index'
import { Route as AuthrequeiredAdminCompaniesIndexImport } from './app/routes/_auth_requeired/admin/companies/index'
import { Route as AuthrequeiredAdminCargosIndexImport } from './app/routes/_auth_requeired/admin/cargos/index'
import { Route as AuthrequeiredAdminAccountRequestsIndexImport } from './app/routes/_auth_requeired/admin/account-requests/index'
import { Route as AuthrequeiredShipperCargosCreateImport } from './app/routes/_auth_requeired/shipper/cargos/create'
import { Route as AuthrequeiredMasterDataVehiclesCreateImport } from './app/routes/_auth_requeired/master-data/vehicles/create'
import { Route as AuthrequeiredAdminCargosCreateImport } from './app/routes/_auth_requeired/admin/cargos/create'
import { Route as AuthrequeiredShipperDeliveryProposalsIdIndexImport } from './app/routes/_auth_requeired/shipper/delivery-proposals/$id/index'
import { Route as AuthrequeiredShipperCargosCargoIdIndexImport } from './app/routes/_auth_requeired/shipper/cargos/$cargoId/index'
import { Route as AuthrequeiredMasterDataVehiclesIdIndexImport } from './app/routes/_auth_requeired/master-data/vehicles/$id/index'
import { Route as AuthrequeiredCarrierCargosIdIndexImport } from './app/routes/_auth_requeired/carrier/cargos/$id/index'
import { Route as AuthrequeiredAdminDeliveryProposalsIdIndexImport } from './app/routes/_auth_requeired/admin/delivery-proposals/$id/index'
import { Route as AuthrequeiredAdminContractsIdIndexImport } from './app/routes/_auth_requeired/admin/contracts/$id/index'
import { Route as AuthrequeiredAdminCompaniesIdIndexImport } from './app/routes/_auth_requeired/admin/companies/$id/index'
import { Route as AuthrequeiredAdminCargosIdIndexImport } from './app/routes/_auth_requeired/admin/cargos/$id/index'
import { Route as AuthrequeiredShipperDeliveryProposalsIdContractsCreateImport } from './app/routes/_auth_requeired/shipper/delivery-proposals/$id/contracts/create'
import { Route as AuthrequeiredCarrierCargosIdDeliveryProposalsCreateImport } from './app/routes/_auth_requeired/carrier/cargos/$id/delivery-proposals/create'
import { Route as AuthrequeiredAdminDeliveryProposalsIdContractsCreateImport } from './app/routes/_auth_requeired/admin/delivery-proposals/$id/contracts/create'
import { Route as AuthrequeiredAdminCargosIdDeliveryProposalsCreateImport } from './app/routes/_auth_requeired/admin/cargos/$id/delivery-proposals/create'

// Create/Update Routes

const AuthrequeiredRoute = AuthrequeiredImport.update({
  id: '/_auth_requeired',
  getParentRoute: () => rootRoute,
} as any)

const AuthnotrequeiredRoute = AuthnotrequeiredImport.update({
  id: '/_auth_not_requeired',
  getParentRoute: () => rootRoute,
} as any)

const AuthrequeiredIndexRoute = AuthrequeiredIndexImport.update({
  path: '/',
  getParentRoute: () => AuthrequeiredRoute,
} as any)

const AuthrequeiredHelpRoute = AuthrequeiredHelpImport.update({
  path: '/help',
  getParentRoute: () => AuthrequeiredRoute,
} as any)

const AuthnotrequeiredSignupRoute = AuthnotrequeiredSignupImport.update({
  path: '/signup',
  getParentRoute: () => AuthnotrequeiredRoute,
} as any)

const AuthnotrequeiredRegisterRoute = AuthnotrequeiredRegisterImport.update({
  path: '/register',
  getParentRoute: () => AuthnotrequeiredRoute,
} as any)

const AuthnotrequeiredLogoutRoute = AuthnotrequeiredLogoutImport.update({
  path: '/logout',
  getParentRoute: () => AuthnotrequeiredRoute,
} as any)

const AuthnotrequeiredLoginRoute = AuthnotrequeiredLoginImport.update({
  path: '/login',
  getParentRoute: () => AuthnotrequeiredRoute,
} as any)

const AuthnotrequeiredForgotPasswordRoute =
  AuthnotrequeiredForgotPasswordImport.update({
    path: '/forgot-password',
    getParentRoute: () => AuthnotrequeiredRoute,
  } as any)

const AuthrequeiredShipperIndexRoute = AuthrequeiredShipperIndexImport.update({
  path: '/shipper/',
  getParentRoute: () => AuthrequeiredRoute,
} as any)

const AuthrequeiredNotificationsIndexRoute =
  AuthrequeiredNotificationsIndexImport.update({
    path: '/notifications/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredCarrierIndexRoute = AuthrequeiredCarrierIndexImport.update({
  path: '/carrier/',
  getParentRoute: () => AuthrequeiredRoute,
} as any)

const AuthrequeiredAdminIndexRoute = AuthrequeiredAdminIndexImport.update({
  path: '/admin/',
  getParentRoute: () => AuthrequeiredRoute,
} as any)

const AuthrequeiredShipperCargosIndexRoute =
  AuthrequeiredShipperCargosIndexImport.update({
    path: '/shipper/cargos/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredNotificationsIdIndexRoute =
  AuthrequeiredNotificationsIdIndexImport.update({
    path: '/notifications/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredMasterDataVehiclesIndexRoute =
  AuthrequeiredMasterDataVehiclesIndexImport.update({
    path: '/master-data/vehicles/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredCompaniesIdIndexRoute =
  AuthrequeiredCompaniesIdIndexImport.update({
    path: '/companies/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredCarrierCargosIndexRoute =
  AuthrequeiredCarrierCargosIndexImport.update({
    path: '/carrier/cargos/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminCompaniesIndexRoute =
  AuthrequeiredAdminCompaniesIndexImport.update({
    path: '/admin/companies/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminCargosIndexRoute =
  AuthrequeiredAdminCargosIndexImport.update({
    path: '/admin/cargos/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminAccountRequestsIndexRoute =
  AuthrequeiredAdminAccountRequestsIndexImport.update({
    path: '/admin/account-requests/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredShipperCargosCreateRoute =
  AuthrequeiredShipperCargosCreateImport.update({
    path: '/shipper/cargos/create',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredMasterDataVehiclesCreateRoute =
  AuthrequeiredMasterDataVehiclesCreateImport.update({
    path: '/master-data/vehicles/create',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminCargosCreateRoute =
  AuthrequeiredAdminCargosCreateImport.update({
    path: '/admin/cargos/create',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredShipperDeliveryProposalsIdIndexRoute =
  AuthrequeiredShipperDeliveryProposalsIdIndexImport.update({
    path: '/shipper/delivery-proposals/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredShipperCargosCargoIdIndexRoute =
  AuthrequeiredShipperCargosCargoIdIndexImport.update({
    path: '/shipper/cargos/$cargoId/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredMasterDataVehiclesIdIndexRoute =
  AuthrequeiredMasterDataVehiclesIdIndexImport.update({
    path: '/master-data/vehicles/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredCarrierCargosIdIndexRoute =
  AuthrequeiredCarrierCargosIdIndexImport.update({
    path: '/carrier/cargos/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminDeliveryProposalsIdIndexRoute =
  AuthrequeiredAdminDeliveryProposalsIdIndexImport.update({
    path: '/admin/delivery-proposals/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminContractsIdIndexRoute =
  AuthrequeiredAdminContractsIdIndexImport.update({
    path: '/admin/contracts/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminCompaniesIdIndexRoute =
  AuthrequeiredAdminCompaniesIdIndexImport.update({
    path: '/admin/companies/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminCargosIdIndexRoute =
  AuthrequeiredAdminCargosIdIndexImport.update({
    path: '/admin/cargos/$id/',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute =
  AuthrequeiredShipperDeliveryProposalsIdContractsCreateImport.update({
    path: '/shipper/delivery-proposals/$id/contracts/create',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute =
  AuthrequeiredCarrierCargosIdDeliveryProposalsCreateImport.update({
    path: '/carrier/cargos/$id/delivery-proposals/create',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute =
  AuthrequeiredAdminDeliveryProposalsIdContractsCreateImport.update({
    path: '/admin/delivery-proposals/$id/contracts/create',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

const AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute =
  AuthrequeiredAdminCargosIdDeliveryProposalsCreateImport.update({
    path: '/admin/cargos/$id/delivery-proposals/create',
    getParentRoute: () => AuthrequeiredRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth_not_requeired': {
      id: '/_auth_not_requeired'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthnotrequeiredImport
      parentRoute: typeof rootRoute
    }
    '/_auth_requeired': {
      id: '/_auth_requeired'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthrequeiredImport
      parentRoute: typeof rootRoute
    }
    '/_auth_not_requeired/forgot-password': {
      id: '/_auth_not_requeired/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthnotrequeiredForgotPasswordImport
      parentRoute: typeof AuthnotrequeiredImport
    }
    '/_auth_not_requeired/login': {
      id: '/_auth_not_requeired/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthnotrequeiredLoginImport
      parentRoute: typeof AuthnotrequeiredImport
    }
    '/_auth_not_requeired/logout': {
      id: '/_auth_not_requeired/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthnotrequeiredLogoutImport
      parentRoute: typeof AuthnotrequeiredImport
    }
    '/_auth_not_requeired/register': {
      id: '/_auth_not_requeired/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthnotrequeiredRegisterImport
      parentRoute: typeof AuthnotrequeiredImport
    }
    '/_auth_not_requeired/signup': {
      id: '/_auth_not_requeired/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthnotrequeiredSignupImport
      parentRoute: typeof AuthnotrequeiredImport
    }
    '/_auth_requeired/help': {
      id: '/_auth_requeired/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AuthrequeiredHelpImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/': {
      id: '/_auth_requeired/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthrequeiredIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/': {
      id: '/_auth_requeired/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthrequeiredAdminIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/carrier/': {
      id: '/_auth_requeired/carrier/'
      path: '/carrier'
      fullPath: '/carrier'
      preLoaderRoute: typeof AuthrequeiredCarrierIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/notifications/': {
      id: '/_auth_requeired/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthrequeiredNotificationsIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/shipper/': {
      id: '/_auth_requeired/shipper/'
      path: '/shipper'
      fullPath: '/shipper'
      preLoaderRoute: typeof AuthrequeiredShipperIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/cargos/create': {
      id: '/_auth_requeired/admin/cargos/create'
      path: '/admin/cargos/create'
      fullPath: '/admin/cargos/create'
      preLoaderRoute: typeof AuthrequeiredAdminCargosCreateImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/master-data/vehicles/create': {
      id: '/_auth_requeired/master-data/vehicles/create'
      path: '/master-data/vehicles/create'
      fullPath: '/master-data/vehicles/create'
      preLoaderRoute: typeof AuthrequeiredMasterDataVehiclesCreateImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/shipper/cargos/create': {
      id: '/_auth_requeired/shipper/cargos/create'
      path: '/shipper/cargos/create'
      fullPath: '/shipper/cargos/create'
      preLoaderRoute: typeof AuthrequeiredShipperCargosCreateImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/account-requests/': {
      id: '/_auth_requeired/admin/account-requests/'
      path: '/admin/account-requests'
      fullPath: '/admin/account-requests'
      preLoaderRoute: typeof AuthrequeiredAdminAccountRequestsIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/cargos/': {
      id: '/_auth_requeired/admin/cargos/'
      path: '/admin/cargos'
      fullPath: '/admin/cargos'
      preLoaderRoute: typeof AuthrequeiredAdminCargosIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/companies/': {
      id: '/_auth_requeired/admin/companies/'
      path: '/admin/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AuthrequeiredAdminCompaniesIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/carrier/cargos/': {
      id: '/_auth_requeired/carrier/cargos/'
      path: '/carrier/cargos'
      fullPath: '/carrier/cargos'
      preLoaderRoute: typeof AuthrequeiredCarrierCargosIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/companies/$id/': {
      id: '/_auth_requeired/companies/$id/'
      path: '/companies/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof AuthrequeiredCompaniesIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/master-data/vehicles/': {
      id: '/_auth_requeired/master-data/vehicles/'
      path: '/master-data/vehicles'
      fullPath: '/master-data/vehicles'
      preLoaderRoute: typeof AuthrequeiredMasterDataVehiclesIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/notifications/$id/': {
      id: '/_auth_requeired/notifications/$id/'
      path: '/notifications/$id'
      fullPath: '/notifications/$id'
      preLoaderRoute: typeof AuthrequeiredNotificationsIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/shipper/cargos/': {
      id: '/_auth_requeired/shipper/cargos/'
      path: '/shipper/cargos'
      fullPath: '/shipper/cargos'
      preLoaderRoute: typeof AuthrequeiredShipperCargosIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/cargos/$id/': {
      id: '/_auth_requeired/admin/cargos/$id/'
      path: '/admin/cargos/$id'
      fullPath: '/admin/cargos/$id'
      preLoaderRoute: typeof AuthrequeiredAdminCargosIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/companies/$id/': {
      id: '/_auth_requeired/admin/companies/$id/'
      path: '/admin/companies/$id'
      fullPath: '/admin/companies/$id'
      preLoaderRoute: typeof AuthrequeiredAdminCompaniesIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/contracts/$id/': {
      id: '/_auth_requeired/admin/contracts/$id/'
      path: '/admin/contracts/$id'
      fullPath: '/admin/contracts/$id'
      preLoaderRoute: typeof AuthrequeiredAdminContractsIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/delivery-proposals/$id/': {
      id: '/_auth_requeired/admin/delivery-proposals/$id/'
      path: '/admin/delivery-proposals/$id'
      fullPath: '/admin/delivery-proposals/$id'
      preLoaderRoute: typeof AuthrequeiredAdminDeliveryProposalsIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/carrier/cargos/$id/': {
      id: '/_auth_requeired/carrier/cargos/$id/'
      path: '/carrier/cargos/$id'
      fullPath: '/carrier/cargos/$id'
      preLoaderRoute: typeof AuthrequeiredCarrierCargosIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/master-data/vehicles/$id/': {
      id: '/_auth_requeired/master-data/vehicles/$id/'
      path: '/master-data/vehicles/$id'
      fullPath: '/master-data/vehicles/$id'
      preLoaderRoute: typeof AuthrequeiredMasterDataVehiclesIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/shipper/cargos/$cargoId/': {
      id: '/_auth_requeired/shipper/cargos/$cargoId/'
      path: '/shipper/cargos/$cargoId'
      fullPath: '/shipper/cargos/$cargoId'
      preLoaderRoute: typeof AuthrequeiredShipperCargosCargoIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/shipper/delivery-proposals/$id/': {
      id: '/_auth_requeired/shipper/delivery-proposals/$id/'
      path: '/shipper/delivery-proposals/$id'
      fullPath: '/shipper/delivery-proposals/$id'
      preLoaderRoute: typeof AuthrequeiredShipperDeliveryProposalsIdIndexImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/cargos/$id/delivery-proposals/create': {
      id: '/_auth_requeired/admin/cargos/$id/delivery-proposals/create'
      path: '/admin/cargos/$id/delivery-proposals/create'
      fullPath: '/admin/cargos/$id/delivery-proposals/create'
      preLoaderRoute: typeof AuthrequeiredAdminCargosIdDeliveryProposalsCreateImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/admin/delivery-proposals/$id/contracts/create': {
      id: '/_auth_requeired/admin/delivery-proposals/$id/contracts/create'
      path: '/admin/delivery-proposals/$id/contracts/create'
      fullPath: '/admin/delivery-proposals/$id/contracts/create'
      preLoaderRoute: typeof AuthrequeiredAdminDeliveryProposalsIdContractsCreateImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/carrier/cargos/$id/delivery-proposals/create': {
      id: '/_auth_requeired/carrier/cargos/$id/delivery-proposals/create'
      path: '/carrier/cargos/$id/delivery-proposals/create'
      fullPath: '/carrier/cargos/$id/delivery-proposals/create'
      preLoaderRoute: typeof AuthrequeiredCarrierCargosIdDeliveryProposalsCreateImport
      parentRoute: typeof AuthrequeiredImport
    }
    '/_auth_requeired/shipper/delivery-proposals/$id/contracts/create': {
      id: '/_auth_requeired/shipper/delivery-proposals/$id/contracts/create'
      path: '/shipper/delivery-proposals/$id/contracts/create'
      fullPath: '/shipper/delivery-proposals/$id/contracts/create'
      preLoaderRoute: typeof AuthrequeiredShipperDeliveryProposalsIdContractsCreateImport
      parentRoute: typeof AuthrequeiredImport
    }
  }
}

// Create and export the route tree

interface AuthnotrequeiredRouteChildren {
  AuthnotrequeiredForgotPasswordRoute: typeof AuthnotrequeiredForgotPasswordRoute
  AuthnotrequeiredLoginRoute: typeof AuthnotrequeiredLoginRoute
  AuthnotrequeiredLogoutRoute: typeof AuthnotrequeiredLogoutRoute
  AuthnotrequeiredRegisterRoute: typeof AuthnotrequeiredRegisterRoute
  AuthnotrequeiredSignupRoute: typeof AuthnotrequeiredSignupRoute
}

const AuthnotrequeiredRouteChildren: AuthnotrequeiredRouteChildren = {
  AuthnotrequeiredForgotPasswordRoute: AuthnotrequeiredForgotPasswordRoute,
  AuthnotrequeiredLoginRoute: AuthnotrequeiredLoginRoute,
  AuthnotrequeiredLogoutRoute: AuthnotrequeiredLogoutRoute,
  AuthnotrequeiredRegisterRoute: AuthnotrequeiredRegisterRoute,
  AuthnotrequeiredSignupRoute: AuthnotrequeiredSignupRoute,
}

const AuthnotrequeiredRouteWithChildren =
  AuthnotrequeiredRoute._addFileChildren(AuthnotrequeiredRouteChildren)

interface AuthrequeiredRouteChildren {
  AuthrequeiredHelpRoute: typeof AuthrequeiredHelpRoute
  AuthrequeiredIndexRoute: typeof AuthrequeiredIndexRoute
  AuthrequeiredAdminIndexRoute: typeof AuthrequeiredAdminIndexRoute
  AuthrequeiredCarrierIndexRoute: typeof AuthrequeiredCarrierIndexRoute
  AuthrequeiredNotificationsIndexRoute: typeof AuthrequeiredNotificationsIndexRoute
  AuthrequeiredShipperIndexRoute: typeof AuthrequeiredShipperIndexRoute
  AuthrequeiredAdminCargosCreateRoute: typeof AuthrequeiredAdminCargosCreateRoute
  AuthrequeiredMasterDataVehiclesCreateRoute: typeof AuthrequeiredMasterDataVehiclesCreateRoute
  AuthrequeiredShipperCargosCreateRoute: typeof AuthrequeiredShipperCargosCreateRoute
  AuthrequeiredAdminAccountRequestsIndexRoute: typeof AuthrequeiredAdminAccountRequestsIndexRoute
  AuthrequeiredAdminCargosIndexRoute: typeof AuthrequeiredAdminCargosIndexRoute
  AuthrequeiredAdminCompaniesIndexRoute: typeof AuthrequeiredAdminCompaniesIndexRoute
  AuthrequeiredCarrierCargosIndexRoute: typeof AuthrequeiredCarrierCargosIndexRoute
  AuthrequeiredCompaniesIdIndexRoute: typeof AuthrequeiredCompaniesIdIndexRoute
  AuthrequeiredMasterDataVehiclesIndexRoute: typeof AuthrequeiredMasterDataVehiclesIndexRoute
  AuthrequeiredNotificationsIdIndexRoute: typeof AuthrequeiredNotificationsIdIndexRoute
  AuthrequeiredShipperCargosIndexRoute: typeof AuthrequeiredShipperCargosIndexRoute
  AuthrequeiredAdminCargosIdIndexRoute: typeof AuthrequeiredAdminCargosIdIndexRoute
  AuthrequeiredAdminCompaniesIdIndexRoute: typeof AuthrequeiredAdminCompaniesIdIndexRoute
  AuthrequeiredAdminContractsIdIndexRoute: typeof AuthrequeiredAdminContractsIdIndexRoute
  AuthrequeiredAdminDeliveryProposalsIdIndexRoute: typeof AuthrequeiredAdminDeliveryProposalsIdIndexRoute
  AuthrequeiredCarrierCargosIdIndexRoute: typeof AuthrequeiredCarrierCargosIdIndexRoute
  AuthrequeiredMasterDataVehiclesIdIndexRoute: typeof AuthrequeiredMasterDataVehiclesIdIndexRoute
  AuthrequeiredShipperCargosCargoIdIndexRoute: typeof AuthrequeiredShipperCargosCargoIdIndexRoute
  AuthrequeiredShipperDeliveryProposalsIdIndexRoute: typeof AuthrequeiredShipperDeliveryProposalsIdIndexRoute
  AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute: typeof AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute
  AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute: typeof AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute
  AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute: typeof AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute
  AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute: typeof AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute
}

const AuthrequeiredRouteChildren: AuthrequeiredRouteChildren = {
  AuthrequeiredHelpRoute: AuthrequeiredHelpRoute,
  AuthrequeiredIndexRoute: AuthrequeiredIndexRoute,
  AuthrequeiredAdminIndexRoute: AuthrequeiredAdminIndexRoute,
  AuthrequeiredCarrierIndexRoute: AuthrequeiredCarrierIndexRoute,
  AuthrequeiredNotificationsIndexRoute: AuthrequeiredNotificationsIndexRoute,
  AuthrequeiredShipperIndexRoute: AuthrequeiredShipperIndexRoute,
  AuthrequeiredAdminCargosCreateRoute: AuthrequeiredAdminCargosCreateRoute,
  AuthrequeiredMasterDataVehiclesCreateRoute:
    AuthrequeiredMasterDataVehiclesCreateRoute,
  AuthrequeiredShipperCargosCreateRoute: AuthrequeiredShipperCargosCreateRoute,
  AuthrequeiredAdminAccountRequestsIndexRoute:
    AuthrequeiredAdminAccountRequestsIndexRoute,
  AuthrequeiredAdminCargosIndexRoute: AuthrequeiredAdminCargosIndexRoute,
  AuthrequeiredAdminCompaniesIndexRoute: AuthrequeiredAdminCompaniesIndexRoute,
  AuthrequeiredCarrierCargosIndexRoute: AuthrequeiredCarrierCargosIndexRoute,
  AuthrequeiredCompaniesIdIndexRoute: AuthrequeiredCompaniesIdIndexRoute,
  AuthrequeiredMasterDataVehiclesIndexRoute:
    AuthrequeiredMasterDataVehiclesIndexRoute,
  AuthrequeiredNotificationsIdIndexRoute:
    AuthrequeiredNotificationsIdIndexRoute,
  AuthrequeiredShipperCargosIndexRoute: AuthrequeiredShipperCargosIndexRoute,
  AuthrequeiredAdminCargosIdIndexRoute: AuthrequeiredAdminCargosIdIndexRoute,
  AuthrequeiredAdminCompaniesIdIndexRoute:
    AuthrequeiredAdminCompaniesIdIndexRoute,
  AuthrequeiredAdminContractsIdIndexRoute:
    AuthrequeiredAdminContractsIdIndexRoute,
  AuthrequeiredAdminDeliveryProposalsIdIndexRoute:
    AuthrequeiredAdminDeliveryProposalsIdIndexRoute,
  AuthrequeiredCarrierCargosIdIndexRoute:
    AuthrequeiredCarrierCargosIdIndexRoute,
  AuthrequeiredMasterDataVehiclesIdIndexRoute:
    AuthrequeiredMasterDataVehiclesIdIndexRoute,
  AuthrequeiredShipperCargosCargoIdIndexRoute:
    AuthrequeiredShipperCargosCargoIdIndexRoute,
  AuthrequeiredShipperDeliveryProposalsIdIndexRoute:
    AuthrequeiredShipperDeliveryProposalsIdIndexRoute,
  AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute:
    AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute,
  AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute:
    AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute,
  AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute:
    AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute,
  AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute:
    AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute,
}

const AuthrequeiredRouteWithChildren = AuthrequeiredRoute._addFileChildren(
  AuthrequeiredRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthrequeiredRouteWithChildren
  '/forgot-password': typeof AuthnotrequeiredForgotPasswordRoute
  '/login': typeof AuthnotrequeiredLoginRoute
  '/logout': typeof AuthnotrequeiredLogoutRoute
  '/register': typeof AuthnotrequeiredRegisterRoute
  '/signup': typeof AuthnotrequeiredSignupRoute
  '/help': typeof AuthrequeiredHelpRoute
  '/': typeof AuthrequeiredIndexRoute
  '/admin': typeof AuthrequeiredAdminIndexRoute
  '/carrier': typeof AuthrequeiredCarrierIndexRoute
  '/notifications': typeof AuthrequeiredNotificationsIndexRoute
  '/shipper': typeof AuthrequeiredShipperIndexRoute
  '/admin/cargos/create': typeof AuthrequeiredAdminCargosCreateRoute
  '/master-data/vehicles/create': typeof AuthrequeiredMasterDataVehiclesCreateRoute
  '/shipper/cargos/create': typeof AuthrequeiredShipperCargosCreateRoute
  '/admin/account-requests': typeof AuthrequeiredAdminAccountRequestsIndexRoute
  '/admin/cargos': typeof AuthrequeiredAdminCargosIndexRoute
  '/admin/companies': typeof AuthrequeiredAdminCompaniesIndexRoute
  '/carrier/cargos': typeof AuthrequeiredCarrierCargosIndexRoute
  '/companies/$id': typeof AuthrequeiredCompaniesIdIndexRoute
  '/master-data/vehicles': typeof AuthrequeiredMasterDataVehiclesIndexRoute
  '/notifications/$id': typeof AuthrequeiredNotificationsIdIndexRoute
  '/shipper/cargos': typeof AuthrequeiredShipperCargosIndexRoute
  '/admin/cargos/$id': typeof AuthrequeiredAdminCargosIdIndexRoute
  '/admin/companies/$id': typeof AuthrequeiredAdminCompaniesIdIndexRoute
  '/admin/contracts/$id': typeof AuthrequeiredAdminContractsIdIndexRoute
  '/admin/delivery-proposals/$id': typeof AuthrequeiredAdminDeliveryProposalsIdIndexRoute
  '/carrier/cargos/$id': typeof AuthrequeiredCarrierCargosIdIndexRoute
  '/master-data/vehicles/$id': typeof AuthrequeiredMasterDataVehiclesIdIndexRoute
  '/shipper/cargos/$cargoId': typeof AuthrequeiredShipperCargosCargoIdIndexRoute
  '/shipper/delivery-proposals/$id': typeof AuthrequeiredShipperDeliveryProposalsIdIndexRoute
  '/admin/cargos/$id/delivery-proposals/create': typeof AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute
  '/admin/delivery-proposals/$id/contracts/create': typeof AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute
  '/carrier/cargos/$id/delivery-proposals/create': typeof AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute
  '/shipper/delivery-proposals/$id/contracts/create': typeof AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute
}

export interface FileRoutesByTo {
  '': typeof AuthnotrequeiredRouteWithChildren
  '/forgot-password': typeof AuthnotrequeiredForgotPasswordRoute
  '/login': typeof AuthnotrequeiredLoginRoute
  '/logout': typeof AuthnotrequeiredLogoutRoute
  '/register': typeof AuthnotrequeiredRegisterRoute
  '/signup': typeof AuthnotrequeiredSignupRoute
  '/help': typeof AuthrequeiredHelpRoute
  '/': typeof AuthrequeiredIndexRoute
  '/admin': typeof AuthrequeiredAdminIndexRoute
  '/carrier': typeof AuthrequeiredCarrierIndexRoute
  '/notifications': typeof AuthrequeiredNotificationsIndexRoute
  '/shipper': typeof AuthrequeiredShipperIndexRoute
  '/admin/cargos/create': typeof AuthrequeiredAdminCargosCreateRoute
  '/master-data/vehicles/create': typeof AuthrequeiredMasterDataVehiclesCreateRoute
  '/shipper/cargos/create': typeof AuthrequeiredShipperCargosCreateRoute
  '/admin/account-requests': typeof AuthrequeiredAdminAccountRequestsIndexRoute
  '/admin/cargos': typeof AuthrequeiredAdminCargosIndexRoute
  '/admin/companies': typeof AuthrequeiredAdminCompaniesIndexRoute
  '/carrier/cargos': typeof AuthrequeiredCarrierCargosIndexRoute
  '/companies/$id': typeof AuthrequeiredCompaniesIdIndexRoute
  '/master-data/vehicles': typeof AuthrequeiredMasterDataVehiclesIndexRoute
  '/notifications/$id': typeof AuthrequeiredNotificationsIdIndexRoute
  '/shipper/cargos': typeof AuthrequeiredShipperCargosIndexRoute
  '/admin/cargos/$id': typeof AuthrequeiredAdminCargosIdIndexRoute
  '/admin/companies/$id': typeof AuthrequeiredAdminCompaniesIdIndexRoute
  '/admin/contracts/$id': typeof AuthrequeiredAdminContractsIdIndexRoute
  '/admin/delivery-proposals/$id': typeof AuthrequeiredAdminDeliveryProposalsIdIndexRoute
  '/carrier/cargos/$id': typeof AuthrequeiredCarrierCargosIdIndexRoute
  '/master-data/vehicles/$id': typeof AuthrequeiredMasterDataVehiclesIdIndexRoute
  '/shipper/cargos/$cargoId': typeof AuthrequeiredShipperCargosCargoIdIndexRoute
  '/shipper/delivery-proposals/$id': typeof AuthrequeiredShipperDeliveryProposalsIdIndexRoute
  '/admin/cargos/$id/delivery-proposals/create': typeof AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute
  '/admin/delivery-proposals/$id/contracts/create': typeof AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute
  '/carrier/cargos/$id/delivery-proposals/create': typeof AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute
  '/shipper/delivery-proposals/$id/contracts/create': typeof AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth_not_requeired': typeof AuthnotrequeiredRouteWithChildren
  '/_auth_requeired': typeof AuthrequeiredRouteWithChildren
  '/_auth_not_requeired/forgot-password': typeof AuthnotrequeiredForgotPasswordRoute
  '/_auth_not_requeired/login': typeof AuthnotrequeiredLoginRoute
  '/_auth_not_requeired/logout': typeof AuthnotrequeiredLogoutRoute
  '/_auth_not_requeired/register': typeof AuthnotrequeiredRegisterRoute
  '/_auth_not_requeired/signup': typeof AuthnotrequeiredSignupRoute
  '/_auth_requeired/help': typeof AuthrequeiredHelpRoute
  '/_auth_requeired/': typeof AuthrequeiredIndexRoute
  '/_auth_requeired/admin/': typeof AuthrequeiredAdminIndexRoute
  '/_auth_requeired/carrier/': typeof AuthrequeiredCarrierIndexRoute
  '/_auth_requeired/notifications/': typeof AuthrequeiredNotificationsIndexRoute
  '/_auth_requeired/shipper/': typeof AuthrequeiredShipperIndexRoute
  '/_auth_requeired/admin/cargos/create': typeof AuthrequeiredAdminCargosCreateRoute
  '/_auth_requeired/master-data/vehicles/create': typeof AuthrequeiredMasterDataVehiclesCreateRoute
  '/_auth_requeired/shipper/cargos/create': typeof AuthrequeiredShipperCargosCreateRoute
  '/_auth_requeired/admin/account-requests/': typeof AuthrequeiredAdminAccountRequestsIndexRoute
  '/_auth_requeired/admin/cargos/': typeof AuthrequeiredAdminCargosIndexRoute
  '/_auth_requeired/admin/companies/': typeof AuthrequeiredAdminCompaniesIndexRoute
  '/_auth_requeired/carrier/cargos/': typeof AuthrequeiredCarrierCargosIndexRoute
  '/_auth_requeired/companies/$id/': typeof AuthrequeiredCompaniesIdIndexRoute
  '/_auth_requeired/master-data/vehicles/': typeof AuthrequeiredMasterDataVehiclesIndexRoute
  '/_auth_requeired/notifications/$id/': typeof AuthrequeiredNotificationsIdIndexRoute
  '/_auth_requeired/shipper/cargos/': typeof AuthrequeiredShipperCargosIndexRoute
  '/_auth_requeired/admin/cargos/$id/': typeof AuthrequeiredAdminCargosIdIndexRoute
  '/_auth_requeired/admin/companies/$id/': typeof AuthrequeiredAdminCompaniesIdIndexRoute
  '/_auth_requeired/admin/contracts/$id/': typeof AuthrequeiredAdminContractsIdIndexRoute
  '/_auth_requeired/admin/delivery-proposals/$id/': typeof AuthrequeiredAdminDeliveryProposalsIdIndexRoute
  '/_auth_requeired/carrier/cargos/$id/': typeof AuthrequeiredCarrierCargosIdIndexRoute
  '/_auth_requeired/master-data/vehicles/$id/': typeof AuthrequeiredMasterDataVehiclesIdIndexRoute
  '/_auth_requeired/shipper/cargos/$cargoId/': typeof AuthrequeiredShipperCargosCargoIdIndexRoute
  '/_auth_requeired/shipper/delivery-proposals/$id/': typeof AuthrequeiredShipperDeliveryProposalsIdIndexRoute
  '/_auth_requeired/admin/cargos/$id/delivery-proposals/create': typeof AuthrequeiredAdminCargosIdDeliveryProposalsCreateRoute
  '/_auth_requeired/admin/delivery-proposals/$id/contracts/create': typeof AuthrequeiredAdminDeliveryProposalsIdContractsCreateRoute
  '/_auth_requeired/carrier/cargos/$id/delivery-proposals/create': typeof AuthrequeiredCarrierCargosIdDeliveryProposalsCreateRoute
  '/_auth_requeired/shipper/delivery-proposals/$id/contracts/create': typeof AuthrequeiredShipperDeliveryProposalsIdContractsCreateRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/register'
    | '/signup'
    | '/help'
    | '/'
    | '/admin'
    | '/carrier'
    | '/notifications'
    | '/shipper'
    | '/admin/cargos/create'
    | '/master-data/vehicles/create'
    | '/shipper/cargos/create'
    | '/admin/account-requests'
    | '/admin/cargos'
    | '/admin/companies'
    | '/carrier/cargos'
    | '/companies/$id'
    | '/master-data/vehicles'
    | '/notifications/$id'
    | '/shipper/cargos'
    | '/admin/cargos/$id'
    | '/admin/companies/$id'
    | '/admin/contracts/$id'
    | '/admin/delivery-proposals/$id'
    | '/carrier/cargos/$id'
    | '/master-data/vehicles/$id'
    | '/shipper/cargos/$cargoId'
    | '/shipper/delivery-proposals/$id'
    | '/admin/cargos/$id/delivery-proposals/create'
    | '/admin/delivery-proposals/$id/contracts/create'
    | '/carrier/cargos/$id/delivery-proposals/create'
    | '/shipper/delivery-proposals/$id/contracts/create'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/register'
    | '/signup'
    | '/help'
    | '/'
    | '/admin'
    | '/carrier'
    | '/notifications'
    | '/shipper'
    | '/admin/cargos/create'
    | '/master-data/vehicles/create'
    | '/shipper/cargos/create'
    | '/admin/account-requests'
    | '/admin/cargos'
    | '/admin/companies'
    | '/carrier/cargos'
    | '/companies/$id'
    | '/master-data/vehicles'
    | '/notifications/$id'
    | '/shipper/cargos'
    | '/admin/cargos/$id'
    | '/admin/companies/$id'
    | '/admin/contracts/$id'
    | '/admin/delivery-proposals/$id'
    | '/carrier/cargos/$id'
    | '/master-data/vehicles/$id'
    | '/shipper/cargos/$cargoId'
    | '/shipper/delivery-proposals/$id'
    | '/admin/cargos/$id/delivery-proposals/create'
    | '/admin/delivery-proposals/$id/contracts/create'
    | '/carrier/cargos/$id/delivery-proposals/create'
    | '/shipper/delivery-proposals/$id/contracts/create'
  id:
    | '__root__'
    | '/_auth_not_requeired'
    | '/_auth_requeired'
    | '/_auth_not_requeired/forgot-password'
    | '/_auth_not_requeired/login'
    | '/_auth_not_requeired/logout'
    | '/_auth_not_requeired/register'
    | '/_auth_not_requeired/signup'
    | '/_auth_requeired/help'
    | '/_auth_requeired/'
    | '/_auth_requeired/admin/'
    | '/_auth_requeired/carrier/'
    | '/_auth_requeired/notifications/'
    | '/_auth_requeired/shipper/'
    | '/_auth_requeired/admin/cargos/create'
    | '/_auth_requeired/master-data/vehicles/create'
    | '/_auth_requeired/shipper/cargos/create'
    | '/_auth_requeired/admin/account-requests/'
    | '/_auth_requeired/admin/cargos/'
    | '/_auth_requeired/admin/companies/'
    | '/_auth_requeired/carrier/cargos/'
    | '/_auth_requeired/companies/$id/'
    | '/_auth_requeired/master-data/vehicles/'
    | '/_auth_requeired/notifications/$id/'
    | '/_auth_requeired/shipper/cargos/'
    | '/_auth_requeired/admin/cargos/$id/'
    | '/_auth_requeired/admin/companies/$id/'
    | '/_auth_requeired/admin/contracts/$id/'
    | '/_auth_requeired/admin/delivery-proposals/$id/'
    | '/_auth_requeired/carrier/cargos/$id/'
    | '/_auth_requeired/master-data/vehicles/$id/'
    | '/_auth_requeired/shipper/cargos/$cargoId/'
    | '/_auth_requeired/shipper/delivery-proposals/$id/'
    | '/_auth_requeired/admin/cargos/$id/delivery-proposals/create'
    | '/_auth_requeired/admin/delivery-proposals/$id/contracts/create'
    | '/_auth_requeired/carrier/cargos/$id/delivery-proposals/create'
    | '/_auth_requeired/shipper/delivery-proposals/$id/contracts/create'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthnotrequeiredRoute: typeof AuthnotrequeiredRouteWithChildren
  AuthrequeiredRoute: typeof AuthrequeiredRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AuthnotrequeiredRoute: AuthnotrequeiredRouteWithChildren,
  AuthrequeiredRoute: AuthrequeiredRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth_not_requeired",
        "/_auth_requeired"
      ]
    },
    "/_auth_not_requeired": {
      "filePath": "_auth_not_requeired.tsx",
      "children": [
        "/_auth_not_requeired/forgot-password",
        "/_auth_not_requeired/login",
        "/_auth_not_requeired/logout",
        "/_auth_not_requeired/register",
        "/_auth_not_requeired/signup"
      ]
    },
    "/_auth_requeired": {
      "filePath": "_auth_requeired.tsx",
      "children": [
        "/_auth_requeired/help",
        "/_auth_requeired/",
        "/_auth_requeired/admin/",
        "/_auth_requeired/carrier/",
        "/_auth_requeired/notifications/",
        "/_auth_requeired/shipper/",
        "/_auth_requeired/admin/cargos/create",
        "/_auth_requeired/master-data/vehicles/create",
        "/_auth_requeired/shipper/cargos/create",
        "/_auth_requeired/admin/account-requests/",
        "/_auth_requeired/admin/cargos/",
        "/_auth_requeired/admin/companies/",
        "/_auth_requeired/carrier/cargos/",
        "/_auth_requeired/companies/$id/",
        "/_auth_requeired/master-data/vehicles/",
        "/_auth_requeired/notifications/$id/",
        "/_auth_requeired/shipper/cargos/",
        "/_auth_requeired/admin/cargos/$id/",
        "/_auth_requeired/admin/companies/$id/",
        "/_auth_requeired/admin/contracts/$id/",
        "/_auth_requeired/admin/delivery-proposals/$id/",
        "/_auth_requeired/carrier/cargos/$id/",
        "/_auth_requeired/master-data/vehicles/$id/",
        "/_auth_requeired/shipper/cargos/$cargoId/",
        "/_auth_requeired/shipper/delivery-proposals/$id/",
        "/_auth_requeired/admin/cargos/$id/delivery-proposals/create",
        "/_auth_requeired/admin/delivery-proposals/$id/contracts/create",
        "/_auth_requeired/carrier/cargos/$id/delivery-proposals/create",
        "/_auth_requeired/shipper/delivery-proposals/$id/contracts/create"
      ]
    },
    "/_auth_not_requeired/forgot-password": {
      "filePath": "_auth_not_requeired/forgot-password.tsx",
      "parent": "/_auth_not_requeired"
    },
    "/_auth_not_requeired/login": {
      "filePath": "_auth_not_requeired/login.tsx",
      "parent": "/_auth_not_requeired"
    },
    "/_auth_not_requeired/logout": {
      "filePath": "_auth_not_requeired/logout.tsx",
      "parent": "/_auth_not_requeired"
    },
    "/_auth_not_requeired/register": {
      "filePath": "_auth_not_requeired/register.tsx",
      "parent": "/_auth_not_requeired"
    },
    "/_auth_not_requeired/signup": {
      "filePath": "_auth_not_requeired/signup.tsx",
      "parent": "/_auth_not_requeired"
    },
    "/_auth_requeired/help": {
      "filePath": "_auth_requeired/help.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/": {
      "filePath": "_auth_requeired/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/": {
      "filePath": "_auth_requeired/admin/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/carrier/": {
      "filePath": "_auth_requeired/carrier/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/notifications/": {
      "filePath": "_auth_requeired/notifications/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/shipper/": {
      "filePath": "_auth_requeired/shipper/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/cargos/create": {
      "filePath": "_auth_requeired/admin/cargos/create.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/master-data/vehicles/create": {
      "filePath": "_auth_requeired/master-data/vehicles/create.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/shipper/cargos/create": {
      "filePath": "_auth_requeired/shipper/cargos/create.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/account-requests/": {
      "filePath": "_auth_requeired/admin/account-requests/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/cargos/": {
      "filePath": "_auth_requeired/admin/cargos/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/companies/": {
      "filePath": "_auth_requeired/admin/companies/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/carrier/cargos/": {
      "filePath": "_auth_requeired/carrier/cargos/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/companies/$id/": {
      "filePath": "_auth_requeired/companies/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/master-data/vehicles/": {
      "filePath": "_auth_requeired/master-data/vehicles/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/notifications/$id/": {
      "filePath": "_auth_requeired/notifications/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/shipper/cargos/": {
      "filePath": "_auth_requeired/shipper/cargos/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/cargos/$id/": {
      "filePath": "_auth_requeired/admin/cargos/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/companies/$id/": {
      "filePath": "_auth_requeired/admin/companies/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/contracts/$id/": {
      "filePath": "_auth_requeired/admin/contracts/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/delivery-proposals/$id/": {
      "filePath": "_auth_requeired/admin/delivery-proposals/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/carrier/cargos/$id/": {
      "filePath": "_auth_requeired/carrier/cargos/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/master-data/vehicles/$id/": {
      "filePath": "_auth_requeired/master-data/vehicles/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/shipper/cargos/$cargoId/": {
      "filePath": "_auth_requeired/shipper/cargos/$cargoId/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/shipper/delivery-proposals/$id/": {
      "filePath": "_auth_requeired/shipper/delivery-proposals/$id/index.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/cargos/$id/delivery-proposals/create": {
      "filePath": "_auth_requeired/admin/cargos/$id/delivery-proposals/create.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/admin/delivery-proposals/$id/contracts/create": {
      "filePath": "_auth_requeired/admin/delivery-proposals/$id/contracts/create.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/carrier/cargos/$id/delivery-proposals/create": {
      "filePath": "_auth_requeired/carrier/cargos/$id/delivery-proposals/create.tsx",
      "parent": "/_auth_requeired"
    },
    "/_auth_requeired/shipper/delivery-proposals/$id/contracts/create": {
      "filePath": "_auth_requeired/shipper/delivery-proposals/$id/contracts/create.tsx",
      "parent": "/_auth_requeired"
    }
  }
}
ROUTE_MANIFEST_END */
